import React from 'react';

import { Partner } from '../../utils/backend-api/partners';
import { Button } from '../BaseUI';
import styles from './styles.module.css';

interface PartnerProps {
  partner: Partner;
}

const PartnerCard = ({ partner }: PartnerProps) => {
  const { id, name, logo, description, buttonText, targetLink } = partner;

  return (
    <div className={styles.partner}>
      <img src={logo} className={styles.logo} />
      <div className={styles.details}>
        <h3 className={styles.name}>{name}</h3>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          href={targetLink}
          className={styles.button}
          variant="outline"
          rounded="slight"
          borderWidth="medium"
          trackClick
          trackingProps={{
            name: 'partner_card',
            identifier: id.toString(),
          }}
        >
          {buttonText || 'LEARN MORE'}
        </Button>
      </div>
    </div>
  );
};

export default PartnerCard;
